import SpeakerCard, { SpeakerCardProps } from "../components/SpeakerCard";

type SpeakerSectionProps = {
  title: string;
  subtitle: string;
  speakers: SpeakerCardProps[];
};

const SpeakerSection = (props: SpeakerSectionProps) => {
  return (
    <>
      <div className="speakers-header">
        <h1 dangerouslySetInnerHTML={{ __html: props.title }} />
        <p dangerouslySetInnerHTML={{ __html: props.subtitle }} />
      </div>
      <div className="speakers-wrapper">
        {props.speakers.map((speaker, index) => (
          <SpeakerCard key={index} {...speaker} />
        ))}
      </div>
    </>
  );
};

export default SpeakerSection;
